import Parser from 'html-react-parser';
import l from '../../../../../lang';
import FolderMinusIcon from '../../../../../assets/icons/folder-minus.svg?url';
import './styles.scss';

export const EmptyStats = () => (
  <div className="empty__no_transactions">
    <img src={FolderMinusIcon} alt="" />
    {Parser(l('affiliations.affiliates.noAffiliates'))}
  </div>
);
